import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, App } from 'ionic-angular';

@IonicPage()
@Component({
  selector: 'page-welcome',
  templateUrl: 'welcome.html',
})
export class WelcomePage {

  constructor(public navCtrl: NavController, public navParams: NavParams, public app: App) {
    this.doLogout();
  }

  ionViewDidLoad() {

  }

  doLogout() {
    sessionStorage.removeItem("__aid__");
    sessionStorage.removeItem("__jwt__");
    sessionStorage.removeItem("__uid__");
    const root = this.app.getRootNav();
    root.popToRoot();
  };
}


// WEBPACK FOOTER //
// ./src/pages/welcome/welcome.ts